/**
 * Brand-aware Suspense fallback for lazy-loaded routes.
 *
 * Visible while the JS chunk for a route is downloading + parsing
 * (typically 50-300ms on a warm connection, longer on first paint).
 * The mark pulses with the brand color so it reads as "the product is
 * fetching", not "something might be broken".
 *
 * Honors prefers-reduced-motion: animation is suppressed but the mark
 * remains tinted, so the fallback still registers visually.
 */
import { BrandLogo } from "./BrandLogo";

export function RouteFallback() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      // 60vh anchors the fallback near the optical center of the viewport
      // without sticking it to the absolute middle (which feels heavy when
      // the navbar is also visible above).
      style={{ minHeight: "60vh" }}
    >
      <div
        // Re-use the existing skeleton-pulse keyframe so we share one
        // animation definition site (theme.scss). 1.6s is slightly slower
        // than the table-skeleton pulse — code-load is shorter and a
        // gentler beat reads as "almost there" rather than "still busy".
        style={{
          animation: "naas-skel-pulse 1.6s ease-in-out infinite",
        }}
      >
        <BrandLogo size="lg" showWordmark={false} />
      </div>
    </div>
  );
}
